import { Layout } from 'antd';
import type { PropsWithChildren } from 'react';

import { ReduxProvider } from '@/components/redux-provider';
import { ScopeHeadersProvider } from '@/components/scope-headers-provider';
import { useSidebarContext } from '@/contexts/sidebar-context';
import { useSettingsNavigation } from '@/hooks/use-settings-navigation';

import { SettingsBreadcrumb } from './settings-breadcrumb';
import { SettingsNavbar } from './settings-navbar';
import { SettingsSidebar } from './settings-sidebar';

const { Content } = Layout;

function LayoutContent({ children }: PropsWithChildren) {
  const { desktop } = useSidebarContext();

  return (
    <Layout>
      <SettingsSidebar />

      <Layout
        style={{
          marginLeft: desktop.isCollapsed ? 64 : 256,
          transition: 'margin-left 0.2s',
        }}
      >
        <Content
          style={{
            minHeight: 'calc(100vh - 64px)',
          }}
        >
          <div className="p-6">
            <SettingsBreadcrumb />
            {children}
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}

export function SettingsLayoutWrapper({ children }: PropsWithChildren) {
  // Enable automatic context tracking for settings navigation
  useSettingsNavigation();

  return (
    <ReduxProvider>
      <ScopeHeadersProvider>
        <Layout className="min-h-screen">
          <SettingsNavbar />
          <LayoutContent>{children}</LayoutContent>
        </Layout>
      </ScopeHeadersProvider>
    </ReduxProvider>
  );
}
